<template>
  <v-form
    ref="form"
    :data="form"
    :url="
      $laravel.route('api.property.duplicate', {
        property: property.id,
      })
    "
    :method="'post'"
    @success="success"
  >
    <div class="field">
      <v-input v-model="form.address_2" required type="text" name="address_2" />
    </div>
    <div class="field">
      <v-input
        v-model="form.floor_number"
        required
        type="text"
        name="floor_number"
      />
    </div>

    <div class="field">
      <v-input
        v-model="form.number_of_balconies"
        required
        type="number"
        name="number_of_balconies"
      />
    </div>
    <div class="field">
      <v-input
        v-model="form.square_feet_area"
        required
        type="number"
        name="square_feet_area"
      />
    </div>
    <button
      class="button is-default"
      type="button"
      @click="closeDuplicateProperty"
    >
      {{ $t("close") }}
    </button>
    <button class="button is-primary" type="submit">
      {{ $t("save") }}
    </button>
  </v-form>
</template>

<script>
export default {
  props: {
    property: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      form: {
        address_2: "",
        floor_number: "",
        number_of_balconies: "",
        square_feet_area: this.property.square_feet_area,
      },
    };
  },
  created() {},
  methods: {
    closeDuplicateProperty() {
      this.$emit("close", true);
    },
    success(payload) {
      this.$emit("success", payload);
    },
  },
};
</script>
